import api from "./api";
import { AxiosResponse } from "axios";

export type TermsVersionResponse = {
  id: string;
  version: string;
  uploadedAt: string;
  uploadedBy: string;
  fileName: string;
  url: string;
  isActive: boolean;
};

export type GetTermsResponseType = {
  data: TermsVersionResponse[];
};

export type UploadTermsRequestType = {
  file: File;
  version: string;
};

export type UploadTermsResponseType = {
  data: TermsVersionResponse;
};

export const getTermsVersions = (
  countryCode: string
): Promise<AxiosResponse<GetTermsResponseType>> => {
  return api.get(`/ms-admin-rest/api/v1.0/terms`, {
    headers: {
      "country-code": countryCode,
    },
  });
};

export const uploadTermsVersion = async (
  countryCode: string,
  file: File,
  userId: number
): Promise<AxiosResponse<UploadTermsResponseType>> => {
  const formData = new FormData();
  formData.append("file", file);

  return api.post(`/ms-admin-rest/api/v1.0/terms`, formData, {
    headers: {
      "country-code": countryCode,
      "x-user-id": userId.toString(),
    },
    transformRequest: [
      (data) => {
        if (data instanceof FormData) {
          return data;
        }
        return data;
      },
    ],
  });
};

export const downloadTermsVersion = (
  countryCode: string,
  versionId: string,
  url: string
): Promise<AxiosResponse<Blob>> => {
  return api.get(url, {
    headers: {
      "country-code": countryCode,
    },
    responseType: "blob",
  });
};

